import { render, staticRenderFns } from "./IntelligenceProviderPerformanceTable.vue?vue&type=template&id=b43df18a&scoped=true"
import script from "./IntelligenceProviderPerformanceTable.vue?vue&type=script&lang=js"
export * from "./IntelligenceProviderPerformanceTable.vue?vue&type=script&lang=js"
import style0 from "./IntelligenceProviderPerformanceTable.vue?vue&type=style&index=0&id=b43df18a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43df18a",
  null
  
)

export default component.exports